define('glu/grid/savedViews/components/addNewView',['require','../../../itemView','./savedViewsModel','../../../util','hbs!./addNewView.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../../itemView'),
        SavedViewsModel = require('./savedViewsModel'),
        util = require('../../../util'),
        tmpl = require('hbs!./addNewView.hbs');

    return ItemView.extend({
        template: tmpl,
        tagName: 'ul',
        className: 'item-list grid-add-new-view',

        ui: {
            $input: '.js-grid-save-view-input'
        },

        events: {
            'click .grid-save-view-btn': 'showSaveViewForm',
            'click .js-grid-save-view-cancel-btn': 'showSaveViewLink',
            'submit form': 'saveNewView'
        },

        showLink: true,

        initialize: function(options) {
            this.grid = options.grid;
            this.model = new SavedViewsModel();
            this.savedViewsCollection = options.savedViewsCollection;
        },

        templateHelpers: function() {
            return {
                showLink: this.showLink,
                isEmpty: this.savedViewsCollection.isEmpty(),
                cid: this.cid
            };
        },

        showSaveViewForm: function(e) {
            e.preventDefault();

            this.updateView(false);
            this.focus();
        },

        focus: function() {
            util.defer(function() {
                if (this.isClosed) {
                    return;
                }

                this.ui.$input.focus();
            }.bind(this));
        },

        showSaveViewLink: function(e) {
            e.preventDefault();

            this.updateView(true);
        },

        updateView: function(updateFlag) {
            util.defer(function() {
                if (this.isClosed) {
                    return;
                }
                this.showLink = updateFlag;
                this.render();
            }.bind(this));
        },

        saveNewView: function(e) {
            e.preventDefault();

            if (!this.model.isValid()) {
                return;
            }

            // the current stateModel needs a way to be compared to saved views
            this.grid.stateModel.set({
                id: Date.now() // ensure that IDs are unique across sessions
            });

            var currentState = util.omit(this.grid.stateModel.toJSON(), ['name', 'default']);

            this.model.set(currentState);

            this.savedViewsCollection.add(this.model);
        }
    });
});

